var Z;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function n(i) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (i) => {
    const s = {};
    for (const a of i)
      s[a] = a;
    return s;
  }, t.getValidEnumValues = (i) => {
    const s = t.objectKeys(i).filter((o) => typeof i[i[o]] != "number"), a = {};
    for (const o of s)
      a[o] = i[o];
    return t.objectValues(a);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(s) {
    return i[s];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const s = [];
    for (const a in i)
      Object.prototype.hasOwnProperty.call(i, a) && s.push(a);
    return s;
  }, t.find = (i, s) => {
    for (const a of i)
      if (s(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, s = " | ") {
    return i.map((a) => typeof a == "string" ? `'${a}'` : a).join(s);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (i, s) => typeof s == "bigint" ? s.toString() : s;
})(Z || (Z = {}));
var lt;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(lt || (lt = {}));
const g = Z.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ae = (t) => {
  switch (typeof t) {
    case "undefined":
      return g.undefined;
    case "string":
      return g.string;
    case "number":
      return isNaN(t) ? g.nan : g.number;
    case "boolean":
      return g.boolean;
    case "function":
      return g.function;
    case "bigint":
      return g.bigint;
    case "symbol":
      return g.symbol;
    case "object":
      return Array.isArray(t) ? g.array : t === null ? g.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? g.promise : typeof Map < "u" && t instanceof Map ? g.map : typeof Set < "u" && t instanceof Set ? g.set : typeof Date < "u" && t instanceof Date ? g.date : g.object;
    default:
      return g.unknown;
  }
}, m = Z.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Ft = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class J extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(s) {
      return s.message;
    }, r = { _errors: [] }, i = (s) => {
      for (const a of s.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(i);
        else if (a.code === "invalid_return_type")
          i(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          i(a.argumentsError);
        else if (a.path.length === 0)
          r._errors.push(n(a));
        else {
          let o = r, c = 0;
          for (; c < a.path.length; ) {
            const u = a.path[c];
            c === a.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(n(a))) : o[u] = o[u] || { _errors: [] }, o = o[u], c++;
          }
        }
    };
    return i(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Z.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(e(i))) : r.push(e(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
J.create = (t) => new J(t);
const Ee = (t, e) => {
  let n;
  switch (t.code) {
    case m.invalid_type:
      t.received === g.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case m.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, Z.jsonStringifyReplacer)}`;
      break;
    case m.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Z.joinValues(t.keys, ", ")}`;
      break;
    case m.invalid_union:
      n = "Invalid input";
      break;
    case m.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Z.joinValues(t.options)}`;
      break;
    case m.invalid_enum_value:
      n = `Invalid enum value. Expected ${Z.joinValues(t.options)}, received '${t.received}'`;
      break;
    case m.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case m.invalid_return_type:
      n = "Invalid function return type";
      break;
    case m.invalid_date:
      n = "Invalid date";
      break;
    case m.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : Z.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case m.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case m.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case m.custom:
      n = "Invalid input";
      break;
    case m.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case m.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case m.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, Z.assertNever(t);
  }
  return { message: n };
};
let Tt = Ee;
function Jt(t) {
  Tt = t;
}
function We() {
  return Tt;
}
const He = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: i } = t, s = [...n, ...i.path || []], a = {
    ...i,
    path: s
  };
  let o = "";
  const c = r.filter((u) => !!u).slice().reverse();
  for (const u of c)
    o = u(a, { data: e, defaultError: o }).message;
  return {
    ...i,
    path: s,
    message: i.message || o
  };
}, Gt = [];
function v(t, e) {
  const n = He({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      We(),
      Ee
      // then global default map
    ].filter((r) => !!r)
  });
  t.common.issues.push(n);
}
class V {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return T;
      i.status === "dirty" && e.dirty(), r.push(i.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const i of n)
      r.push({
        key: await i.key,
        value: await i.value
      });
    return V.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const i of n) {
      const { key: s, value: a } = i;
      if (s.status === "aborted" || a.status === "aborted")
        return T;
      s.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), (typeof a.value < "u" || i.alwaysSet) && (r[s.value] = a.value);
    }
    return { status: e.value, value: r };
  }
}
const T = Object.freeze({
  status: "aborted"
}), Et = (t) => ({ status: "dirty", value: t }), q = (t) => ({ status: "valid", value: t }), dt = (t) => t.status === "aborted", ft = (t) => t.status === "dirty", Fe = (t) => t.status === "valid", Je = (t) => typeof Promise < "u" && t instanceof Promise;
var w;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(w || (w = {}));
class Q {
  constructor(e, n, r, i) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const wt = (t, e) => {
  if (Fe(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new J(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function E(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: i } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (a, o) => a.code !== "invalid_type" ? { message: o.defaultError } : typeof o.data > "u" ? { message: r ?? o.defaultError } : { message: n ?? o.defaultError }, description: i };
}
class S {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return ae(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: ae(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new V(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: ae(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Je(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ae(e)
    }, s = this._parseSync({ data: e, path: i.path, parent: i });
    return wt(i, s);
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ae(e)
    }, i = this._parse({ data: e, path: r.path, parent: r }), s = await (Je(i) ? i : Promise.resolve(i));
    return wt(r, s);
  }
  refine(e, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, s) => {
      const a = e(i), o = () => s.addIssue({
        code: m.custom,
        ...r(i)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((c) => c ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, i) => e(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(e) {
    return new X({
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return re.create(this, this._def);
  }
  nullable() {
    return ge.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return G.create(this, this._def);
  }
  promise() {
    return ke.create(this, this._def);
  }
  or(e) {
    return Oe.create([this, e], this._def);
  }
  and(e) {
    return Ie.create(this, e, this._def);
  }
  transform(e) {
    return new X({
      ...E(this._def),
      schema: this,
      typeName: b.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Pe({
      ...E(this._def),
      innerType: this,
      defaultValue: n,
      typeName: b.ZodDefault
    });
  }
  brand() {
    return new Ct({
      typeName: b.ZodBranded,
      type: this,
      ...E(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Qe({
      ...E(this._def),
      innerType: this,
      catchValue: n,
      typeName: b.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Le.create(this, e);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Yt = /^c[^\s-]{8,}$/i, Xt = /^[a-z][a-z0-9]*$/, Qt = /[0-9A-HJKMNP-TV-Z]{26}/, Kt = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, en = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, tn = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u, nn = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, rn = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, sn = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function an(t, e) {
  return !!((e === "v4" || !e) && nn.test(t) || (e === "v6" || !e) && rn.test(t));
}
class H extends S {
  constructor() {
    super(...arguments), this._regex = (e, n, r) => this.refinement((i) => e.test(i), {
      validation: n,
      code: m.invalid_string,
      ...w.errToObj(r)
    }), this.nonempty = (e) => this.min(1, w.errToObj(e)), this.trim = () => new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new H({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== g.string) {
      const s = this._getOrReturnCtx(e);
      return v(
        s,
        {
          code: m.invalid_type,
          expected: g.string,
          received: s.parsedType
        }
        //
      ), T;
    }
    const r = new V();
    let i;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), r.dirty());
      else if (s.kind === "length") {
        const a = e.data.length > s.value, o = e.data.length < s.value;
        (a || o) && (i = this._getOrReturnCtx(e, i), a ? v(i, {
          code: m.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && v(i, {
          code: m.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), r.dirty());
      } else if (s.kind === "email")
        en.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "email",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "emoji")
        tn.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "emoji",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "uuid")
        Kt.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "uuid",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid")
        Yt.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "cuid",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "cuid2")
        Xt.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "cuid2",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "ulid")
        Qt.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "ulid",
          code: m.invalid_string,
          message: s.message
        }), r.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), v(i, {
            validation: "url",
            code: m.invalid_string,
            message: s.message
          }), r.dirty();
        }
      else
        s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "regex",
          code: m.invalid_string,
          message: s.message
        }), r.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.invalid_string,
          validation: { includes: s.value, position: s.position },
          message: s.message
        }), r.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.invalid_string,
          validation: { startsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.invalid_string,
          validation: { endsWith: s.value },
          message: s.message
        }), r.dirty()) : s.kind === "datetime" ? sn(s).test(e.data) || (i = this._getOrReturnCtx(e, i), v(i, {
          code: m.invalid_string,
          validation: "datetime",
          message: s.message
        }), r.dirty()) : s.kind === "ip" ? an(e.data, s.version) || (i = this._getOrReturnCtx(e, i), v(i, {
          validation: "ip",
          code: m.invalid_string,
          message: s.message
        }), r.dirty()) : Z.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _addCheck(e) {
    return new H({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...w.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...w.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...w.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...w.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...w.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...w.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...w.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...w.errToObj(e) });
  }
  datetime(e) {
    var n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      ...w.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...w.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...w.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...w.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...w.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...w.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...w.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...w.errToObj(n)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
H.create = (t) => {
  var e;
  return new H({
    checks: [],
    typeName: b.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...E(t)
  });
};
function on(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, i = n > r ? n : r, s = parseInt(t.toFixed(i).replace(".", "")), a = parseInt(e.toFixed(i).replace(".", ""));
  return s % a / Math.pow(10, i);
}
class ue extends S {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== g.number) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: g.number,
        received: s.parsedType
      }), T;
    }
    let r;
    const i = new V();
    for (const s of this._def.checks)
      s.kind === "int" ? Z.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), i.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? on(e.data, s.value) !== 0 && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.not_finite,
        message: s.message
      }), i.dirty()) : Z.assertNever(s);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, w.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, w.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, w.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, w.toString(n));
  }
  setLimit(e, n, r, i) {
    return new ue({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: w.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ue({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: w.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: w.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: w.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: w.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: w.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: w.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: w.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: w.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: w.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Z.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
ue.create = (t) => new ue({
  checks: [],
  typeName: b.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...E(t)
});
class ce extends S {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== g.bigint) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: g.bigint,
        received: s.parsedType
      }), T;
    }
    let r;
    const i = new V();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), i.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), v(r, {
        code: m.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), i.dirty()) : Z.assertNever(s);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, w.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, w.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, w.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, w.toString(n));
  }
  setLimit(e, n, r, i) {
    return new ce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: w.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: w.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: w.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: w.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: w.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: w.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
ce.create = (t) => {
  var e;
  return new ce({
    checks: [],
    typeName: b.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...E(t)
  });
};
class Se extends S {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== g.boolean) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.boolean,
        received: r.parsedType
      }), T;
    }
    return q(e.data);
  }
}
Se.create = (t) => new Se({
  typeName: b.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...E(t)
});
class pe extends S {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== g.date) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: g.date,
        received: s.parsedType
      }), T;
    }
    if (isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_date
      }), T;
    }
    const r = new V();
    let i;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (i = this._getOrReturnCtx(e, i), v(i, {
        code: m.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), r.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (i = this._getOrReturnCtx(e, i), v(i, {
        code: m.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), r.dirty()) : Z.assertNever(s);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new pe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: w.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: w.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
pe.create = (t) => new pe({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: b.ZodDate,
  ...E(t)
});
class Ge extends S {
  _parse(e) {
    if (this._getType(e) !== g.symbol) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.symbol,
        received: r.parsedType
      }), T;
    }
    return q(e.data);
  }
}
Ge.create = (t) => new Ge({
  typeName: b.ZodSymbol,
  ...E(t)
});
class Ce extends S {
  _parse(e) {
    if (this._getType(e) !== g.undefined) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.undefined,
        received: r.parsedType
      }), T;
    }
    return q(e.data);
  }
}
Ce.create = (t) => new Ce({
  typeName: b.ZodUndefined,
  ...E(t)
});
class Ze extends S {
  _parse(e) {
    if (this._getType(e) !== g.null) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.null,
        received: r.parsedType
      }), T;
    }
    return q(e.data);
  }
}
Ze.create = (t) => new Ze({
  typeName: b.ZodNull,
  ...E(t)
});
class we extends S {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return q(e.data);
  }
}
we.create = (t) => new we({
  typeName: b.ZodAny,
  ...E(t)
});
class he extends S {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return q(e.data);
  }
}
he.create = (t) => new he({
  typeName: b.ZodUnknown,
  ...E(t)
});
class ie extends S {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return v(n, {
      code: m.invalid_type,
      expected: g.never,
      received: n.parsedType
    }), T;
  }
}
ie.create = (t) => new ie({
  typeName: b.ZodNever,
  ...E(t)
});
class Ye extends S {
  _parse(e) {
    if (this._getType(e) !== g.undefined) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.void,
        received: r.parsedType
      }), T;
    }
    return q(e.data);
  }
}
Ye.create = (t) => new Ye({
  typeName: b.ZodVoid,
  ...E(t)
});
class G extends S {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), i = this._def;
    if (n.parsedType !== g.array)
      return v(n, {
        code: m.invalid_type,
        expected: g.array,
        received: n.parsedType
      }), T;
    if (i.exactLength !== null) {
      const a = n.data.length > i.exactLength.value, o = n.data.length < i.exactLength.value;
      (a || o) && (v(n, {
        code: a ? m.too_big : m.too_small,
        minimum: o ? i.exactLength.value : void 0,
        maximum: a ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (v(n, {
      code: m.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (v(n, {
      code: m.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((a, o) => i.type._parseAsync(new Q(n, a, n.path, o)))).then((a) => V.mergeArray(r, a));
    const s = [...n.data].map((a, o) => i.type._parseSync(new Q(n, a, n.path, o)));
    return V.mergeArray(r, s);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new G({
      ...this._def,
      minLength: { value: e, message: w.toString(n) }
    });
  }
  max(e, n) {
    return new G({
      ...this._def,
      maxLength: { value: e, message: w.toString(n) }
    });
  }
  length(e, n) {
    return new G({
      ...this._def,
      exactLength: { value: e, message: w.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
G.create = (t, e) => new G({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: b.ZodArray,
  ...E(e)
});
function ve(t) {
  if (t instanceof M) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = re.create(ve(r));
    }
    return new M({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof G ? new G({
      ...t._def,
      type: ve(t.element)
    }) : t instanceof re ? re.create(ve(t.unwrap())) : t instanceof ge ? ge.create(ve(t.unwrap())) : t instanceof K ? K.create(t.items.map((e) => ve(e))) : t;
}
class M extends S {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = Z.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== g.object) {
      const u = this._getOrReturnCtx(e);
      return v(u, {
        code: m.invalid_type,
        expected: g.object,
        received: u.parsedType
      }), T;
    }
    const { status: r, ctx: i } = this._processInputParams(e), { shape: s, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof ie && this._def.unknownKeys === "strip"))
      for (const u in i.data)
        a.includes(u) || o.push(u);
    const c = [];
    for (const u of a) {
      const l = s[u], f = i.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: l._parse(new Q(i, f, i.path, u)),
        alwaysSet: u in i.data
      });
    }
    if (this._def.catchall instanceof ie) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const l of o)
          c.push({
            key: { status: "valid", value: l },
            value: { status: "valid", value: i.data[l] }
          });
      else if (u === "strict")
        o.length > 0 && (v(i, {
          code: m.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const l of o) {
        const f = i.data[l];
        c.push({
          key: { status: "valid", value: l },
          value: u._parse(
            new Q(i, f, i.path, l)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: l in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const l of c) {
        const f = await l.key;
        u.push({
          key: f,
          value: await l.value,
          alwaysSet: l.alwaysSet
        });
      }
      return u;
    }).then((u) => V.mergeObjectSync(r, u)) : V.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return w.errToObj, new M({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          var i, s, a, o;
          const c = (a = (s = (i = this._def).errorMap) === null || s === void 0 ? void 0 : s.call(i, n, r).message) !== null && a !== void 0 ? a : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (o = w.errToObj(e).message) !== null && o !== void 0 ? o : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new M({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new M({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new M({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new M({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: b.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new M({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return Z.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return Z.objectKeys(this.shape).forEach((r) => {
      e[r] || (n[r] = this.shape[r]);
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ve(this);
  }
  partial(e) {
    const n = {};
    return Z.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      e && !e[r] ? n[r] = i : n[r] = i.optional();
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return Z.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let s = this.shape[r];
        for (; s instanceof re; )
          s = s._def.innerType;
        n[r] = s;
      }
    }), new M({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return St(Z.objectKeys(this.shape));
  }
}
M.create = (t, e) => new M({
  shape: () => t,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: b.ZodObject,
  ...E(e)
});
M.strictCreate = (t, e) => new M({
  shape: () => t,
  unknownKeys: "strict",
  catchall: ie.create(),
  typeName: b.ZodObject,
  ...E(e)
});
M.lazycreate = (t, e) => new M({
  shape: t,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: b.ZodObject,
  ...E(e)
});
class Oe extends S {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function i(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const a = s.map((o) => new J(o.ctx.common.issues));
      return v(n, {
        code: m.invalid_union,
        unionErrors: a
      }), T;
    }
    if (n.common.async)
      return Promise.all(r.map(async (s) => {
        const a = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: n.data,
            path: n.path,
            parent: a
          }),
          ctx: a
        };
      })).then(i);
    {
      let s;
      const a = [];
      for (const c of r) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, l = c._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (l.status === "valid")
          return l;
        l.status === "dirty" && !s && (s = { result: l, ctx: u }), u.common.issues.length && a.push(u.common.issues);
      }
      if (s)
        return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((c) => new J(c));
      return v(n, {
        code: m.invalid_union,
        unionErrors: o
      }), T;
    }
  }
  get options() {
    return this._def.options;
  }
}
Oe.create = (t, e) => new Oe({
  options: t,
  typeName: b.ZodUnion,
  ...E(e)
});
const Be = (t) => t instanceof Re ? Be(t.schema) : t instanceof X ? Be(t.innerType()) : t instanceof Me ? [t.value] : t instanceof le ? t.options : t instanceof je ? Object.keys(t.enum) : t instanceof Pe ? Be(t._def.innerType) : t instanceof Ce ? [void 0] : t instanceof Ze ? [null] : null;
class rt extends S {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== g.object)
      return v(n, {
        code: m.invalid_type,
        expected: g.object,
        received: n.parsedType
      }), T;
    const r = this.discriminator, i = n.data[r], s = this.optionsMap.get(i);
    return s ? n.common.async ? s._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : s._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (v(n, {
      code: m.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), T);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const s of n) {
      const a = Be(s.shape[e]);
      if (!a)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (i.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        i.set(o, s);
      }
    }
    return new rt({
      typeName: b.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: i,
      ...E(r)
    });
  }
}
function ht(t, e) {
  const n = ae(t), r = ae(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === g.object && r === g.object) {
    const i = Z.objectKeys(e), s = Z.objectKeys(t).filter((o) => i.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of s) {
      const c = ht(t[o], e[o]);
      if (!c.valid)
        return { valid: !1 };
      a[o] = c.data;
    }
    return { valid: !0, data: a };
  } else if (n === g.array && r === g.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let s = 0; s < t.length; s++) {
      const a = t[s], o = e[s], c = ht(a, o);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else
    return n === g.date && r === g.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Ie extends S {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = (s, a) => {
      if (dt(s) || dt(a))
        return T;
      const o = ht(s.value, a.value);
      return o.valid ? ((ft(s) || ft(a)) && n.dirty(), { status: n.value, value: o.data }) : (v(r, {
        code: m.invalid_intersection_types
      }), T);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([s, a]) => i(s, a)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Ie.create = (t, e, n) => new Ie({
  left: t,
  right: e,
  typeName: b.ZodIntersection,
  ...E(n)
});
class K extends S {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== g.array)
      return v(r, {
        code: m.invalid_type,
        expected: g.array,
        received: r.parsedType
      }), T;
    if (r.data.length < this._def.items.length)
      return v(r, {
        code: m.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), T;
    !this._def.rest && r.data.length > this._def.items.length && (v(r, {
      code: m.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...r.data].map((a, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new Q(r, a, r.path, o)) : null;
    }).filter((a) => !!a);
    return r.common.async ? Promise.all(s).then((a) => V.mergeArray(n, a)) : V.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new K({
      ...this._def,
      rest: e
    });
  }
}
K.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new K({
    items: t,
    typeName: b.ZodTuple,
    rest: null,
    ...E(e)
  });
};
class Ae extends S {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== g.object)
      return v(r, {
        code: m.invalid_type,
        expected: g.object,
        received: r.parsedType
      }), T;
    const i = [], s = this._def.keyType, a = this._def.valueType;
    for (const o in r.data)
      i.push({
        key: s._parse(new Q(r, o, r.path, o)),
        value: a._parse(new Q(r, r.data[o], r.path, o))
      });
    return r.common.async ? V.mergeObjectAsync(n, i) : V.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof S ? new Ae({
      keyType: e,
      valueType: n,
      typeName: b.ZodRecord,
      ...E(r)
    }) : new Ae({
      keyType: H.create(),
      valueType: e,
      typeName: b.ZodRecord,
      ...E(n)
    });
  }
}
class Xe extends S {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== g.map)
      return v(r, {
        code: m.invalid_type,
        expected: g.map,
        received: r.parsedType
      }), T;
    const i = this._def.keyType, s = this._def.valueType, a = [...r.data.entries()].map(([o, c], u) => ({
      key: i._parse(new Q(r, o, r.path, [u, "key"])),
      value: s._parse(new Q(r, c, r.path, [u, "value"]))
    }));
    if (r.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of a) {
          const u = await c.key, l = await c.value;
          if (u.status === "aborted" || l.status === "aborted")
            return T;
          (u.status === "dirty" || l.status === "dirty") && n.dirty(), o.set(u.value, l.value);
        }
        return { status: n.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of a) {
        const u = c.key, l = c.value;
        if (u.status === "aborted" || l.status === "aborted")
          return T;
        (u.status === "dirty" || l.status === "dirty") && n.dirty(), o.set(u.value, l.value);
      }
      return { status: n.value, value: o };
    }
  }
}
Xe.create = (t, e, n) => new Xe({
  valueType: e,
  keyType: t,
  typeName: b.ZodMap,
  ...E(n)
});
class me extends S {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== g.set)
      return v(r, {
        code: m.invalid_type,
        expected: g.set,
        received: r.parsedType
      }), T;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (v(r, {
      code: m.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (v(r, {
      code: m.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const s = this._def.valueType;
    function a(c) {
      const u = /* @__PURE__ */ new Set();
      for (const l of c) {
        if (l.status === "aborted")
          return T;
        l.status === "dirty" && n.dirty(), u.add(l.value);
      }
      return { status: n.value, value: u };
    }
    const o = [...r.data.values()].map((c, u) => s._parse(new Q(r, c, r.path, u)));
    return r.common.async ? Promise.all(o).then((c) => a(c)) : a(o);
  }
  min(e, n) {
    return new me({
      ...this._def,
      minSize: { value: e, message: w.toString(n) }
    });
  }
  max(e, n) {
    return new me({
      ...this._def,
      maxSize: { value: e, message: w.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (t, e) => new me({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: b.ZodSet,
  ...E(e)
});
class _e extends S {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== g.function)
      return v(n, {
        code: m.invalid_type,
        expected: g.function,
        received: n.parsedType
      }), T;
    function r(o, c) {
      return He({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          We(),
          Ee
        ].filter((u) => !!u),
        issueData: {
          code: m.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(o, c) {
      return He({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          We(),
          Ee
        ].filter((u) => !!u),
        issueData: {
          code: m.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const s = { errorMap: n.common.contextualErrorMap }, a = n.data;
    return this._def.returns instanceof ke ? q(async (...o) => {
      const c = new J([]), u = await this._def.args.parseAsync(o, s).catch((h) => {
        throw c.addIssue(r(o, h)), c;
      }), l = await a(...u);
      return await this._def.returns._def.type.parseAsync(l, s).catch((h) => {
        throw c.addIssue(i(l, h)), c;
      });
    }) : q((...o) => {
      const c = this._def.args.safeParse(o, s);
      if (!c.success)
        throw new J([r(o, c.error)]);
      const u = a(...c.data), l = this._def.returns.safeParse(u, s);
      if (!l.success)
        throw new J([i(u, l.error)]);
      return l.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new _e({
      ...this._def,
      args: K.create(e).rest(he.create())
    });
  }
  returns(e) {
    return new _e({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new _e({
      args: e || K.create([]).rest(he.create()),
      returns: n || he.create(),
      typeName: b.ZodFunction,
      ...E(r)
    });
  }
}
class Re extends S {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Re.create = (t, e) => new Re({
  getter: t,
  typeName: b.ZodLazy,
  ...E(e)
});
class Me extends S {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return v(n, {
        received: n.data,
        code: m.invalid_literal,
        expected: this._def.value
      }), T;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Me.create = (t, e) => new Me({
  value: t,
  typeName: b.ZodLiteral,
  ...E(e)
});
function St(t, e) {
  return new le({
    values: t,
    typeName: b.ZodEnum,
    ...E(e)
  });
}
class le extends S {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return v(n, {
        expected: Z.joinValues(r),
        received: n.parsedType,
        code: m.invalid_type
      }), T;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return v(n, {
        received: n.data,
        code: m.invalid_enum_value,
        options: r
      }), T;
    }
    return q(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e) {
    return le.create(e);
  }
  exclude(e) {
    return le.create(this.options.filter((n) => !e.includes(n)));
  }
}
le.create = St;
class je extends S {
  _parse(e) {
    const n = Z.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== g.string && r.parsedType !== g.number) {
      const i = Z.objectValues(n);
      return v(r, {
        expected: Z.joinValues(i),
        received: r.parsedType,
        code: m.invalid_type
      }), T;
    }
    if (n.indexOf(e.data) === -1) {
      const i = Z.objectValues(n);
      return v(r, {
        received: r.data,
        code: m.invalid_enum_value,
        options: i
      }), T;
    }
    return q(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
je.create = (t, e) => new je({
  values: t,
  typeName: b.ZodNativeEnum,
  ...E(e)
});
class ke extends S {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== g.promise && n.common.async === !1)
      return v(n, {
        code: m.invalid_type,
        expected: g.promise,
        received: n.parsedType
      }), T;
    const r = n.parsedType === g.promise ? n.data : Promise.resolve(n.data);
    return q(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ke.create = (t, e) => new ke({
  type: t,
  typeName: b.ZodPromise,
  ...E(e)
});
class X extends S {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === b.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = this._def.effect || null;
    if (i.type === "preprocess") {
      const a = i.transform(r.data);
      return r.common.async ? Promise.resolve(a).then((o) => this._def.schema._parseAsync({
        data: o,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: a,
        path: r.path,
        parent: r
      });
    }
    const s = {
      addIssue: (a) => {
        v(r, a), a.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), i.type === "refinement") {
      const a = (o) => {
        const c = i.refinement(o, s);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? T : (o.status === "dirty" && n.dirty(), a(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => o.status === "aborted" ? T : (o.status === "dirty" && n.dirty(), a(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Fe(a))
          return a;
        const o = i.transform(a.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => Fe(a) ? Promise.resolve(i.transform(a.value, s)).then((o) => ({ status: n.value, value: o })) : a);
    Z.assertNever(i);
  }
}
X.create = (t, e, n) => new X({
  schema: t,
  typeName: b.ZodEffects,
  effect: e,
  ...E(n)
});
X.createWithPreprocess = (t, e, n) => new X({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: b.ZodEffects,
  ...E(n)
});
class re extends S {
  _parse(e) {
    return this._getType(e) === g.undefined ? q(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
re.create = (t, e) => new re({
  innerType: t,
  typeName: b.ZodOptional,
  ...E(e)
});
class ge extends S {
  _parse(e) {
    return this._getType(e) === g.null ? q(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ge.create = (t, e) => new ge({
  innerType: t,
  typeName: b.ZodNullable,
  ...E(e)
});
class Pe extends S {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === g.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Pe.create = (t, e) => new Pe({
  innerType: t,
  typeName: b.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...E(e)
});
class Qe extends S {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Je(i) ? i.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new J(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new J(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Qe.create = (t, e) => new Qe({
  innerType: t,
  typeName: b.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...E(e)
});
class Ke extends S {
  _parse(e) {
    if (this._getType(e) !== g.nan) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        code: m.invalid_type,
        expected: g.nan,
        received: r.parsedType
      }), T;
    }
    return { status: "valid", value: e.data };
  }
}
Ke.create = (t) => new Ke({
  typeName: b.ZodNaN,
  ...E(t)
});
const un = Symbol("zod_brand");
class Ct extends S {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Le extends S {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? T : s.status === "dirty" ? (n.dirty(), Et(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? T : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new Le({
      in: e,
      out: n,
      typeName: b.ZodPipeline
    });
  }
}
const Zt = (t, e = {}, n) => t ? we.create().superRefine((r, i) => {
  var s, a;
  if (!t(r)) {
    const o = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, c = (a = (s = o.fatal) !== null && s !== void 0 ? s : n) !== null && a !== void 0 ? a : !0, u = typeof o == "string" ? { message: o } : o;
    i.addIssue({ code: "custom", ...u, fatal: c });
  }
}) : we.create(), cn = {
  object: M.lazycreate
};
var b;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline";
})(b || (b = {}));
const ln = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Zt((n) => n instanceof t, e), Ot = H.create, It = ue.create, dn = Ke.create, fn = ce.create, At = Se.create, hn = pe.create, pn = Ge.create, mn = Ce.create, gn = Ze.create, vn = we.create, yn = he.create, _n = ie.create, wn = Ye.create, kn = G.create, bn = M.create, xn = M.strictCreate, Nn = Oe.create, Tn = rt.create, En = Ie.create, Sn = K.create, Cn = Ae.create, Zn = Xe.create, On = me.create, In = _e.create, An = Re.create, Rn = Me.create, Mn = le.create, jn = je.create, Pn = ke.create, kt = X.create, Dn = re.create, Ln = ge.create, Vn = X.createWithPreprocess, Un = Le.create, $n = () => Ot().optional(), qn = () => It().optional(), Bn = () => At().optional(), zn = {
  string: (t) => H.create({ ...t, coerce: !0 }),
  number: (t) => ue.create({ ...t, coerce: !0 }),
  boolean: (t) => Se.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => ce.create({ ...t, coerce: !0 }),
  date: (t) => pe.create({ ...t, coerce: !0 })
}, Wn = T;
var d = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Ee,
  setErrorMap: Jt,
  getErrorMap: We,
  makeIssue: He,
  EMPTY_PATH: Gt,
  addIssueToContext: v,
  ParseStatus: V,
  INVALID: T,
  DIRTY: Et,
  OK: q,
  isAborted: dt,
  isDirty: ft,
  isValid: Fe,
  isAsync: Je,
  get util() {
    return Z;
  },
  get objectUtil() {
    return lt;
  },
  ZodParsedType: g,
  getParsedType: ae,
  ZodType: S,
  ZodString: H,
  ZodNumber: ue,
  ZodBigInt: ce,
  ZodBoolean: Se,
  ZodDate: pe,
  ZodSymbol: Ge,
  ZodUndefined: Ce,
  ZodNull: Ze,
  ZodAny: we,
  ZodUnknown: he,
  ZodNever: ie,
  ZodVoid: Ye,
  ZodArray: G,
  ZodObject: M,
  ZodUnion: Oe,
  ZodDiscriminatedUnion: rt,
  ZodIntersection: Ie,
  ZodTuple: K,
  ZodRecord: Ae,
  ZodMap: Xe,
  ZodSet: me,
  ZodFunction: _e,
  ZodLazy: Re,
  ZodLiteral: Me,
  ZodEnum: le,
  ZodNativeEnum: je,
  ZodPromise: ke,
  ZodEffects: X,
  ZodTransformer: X,
  ZodOptional: re,
  ZodNullable: ge,
  ZodDefault: Pe,
  ZodCatch: Qe,
  ZodNaN: Ke,
  BRAND: un,
  ZodBranded: Ct,
  ZodPipeline: Le,
  custom: Zt,
  Schema: S,
  ZodSchema: S,
  late: cn,
  get ZodFirstPartyTypeKind() {
    return b;
  },
  coerce: zn,
  any: vn,
  array: kn,
  bigint: fn,
  boolean: At,
  date: hn,
  discriminatedUnion: Tn,
  effect: kt,
  enum: Mn,
  function: In,
  instanceof: ln,
  intersection: En,
  lazy: An,
  literal: Rn,
  map: Zn,
  nan: dn,
  nativeEnum: jn,
  never: _n,
  null: gn,
  nullable: Ln,
  number: It,
  object: bn,
  oboolean: Bn,
  onumber: qn,
  optional: Dn,
  ostring: $n,
  pipeline: Un,
  preprocess: Vn,
  promise: Pn,
  record: Cn,
  set: On,
  strictObject: xn,
  string: Ot,
  symbol: pn,
  transformer: kt,
  tuple: Sn,
  undefined: mn,
  union: Nn,
  unknown: yn,
  void: wn,
  NEVER: Wn,
  ZodIssueCode: m,
  quotelessJson: Ft,
  ZodError: J
});
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var ye = 9e15, fe = 1e9, pt = "0123456789abcdef", et = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", tt = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", mt = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -ye,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: ye,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, Rt, ne, x = !0, it = "[DecimalError] ", de = it + "Invalid argument: ", Mt = it + "Precision limit exceeded", jt = it + "crypto unavailable", Pt = "[object Decimal]", U = Math.floor, j = Math.pow, Hn = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, Fn = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, Jn = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Dt = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Y = 1e7, k = 7, Gn = 9007199254740991, Yn = et.length - 1, gt = tt.length - 1, p = { toStringTag: Pt };
p.absoluteValue = p.abs = function() {
  var t = new this.constructor(this);
  return t.s < 0 && (t.s = 1), y(t);
};
p.ceil = function() {
  return y(new this.constructor(this), this.e + 1, 2);
};
p.clampedTo = p.clamp = function(t, e) {
  var n, r = this, i = r.constructor;
  if (t = new i(t), e = new i(e), !t.s || !e.s)
    return new i(NaN);
  if (t.gt(e))
    throw Error(de + e);
  return n = r.cmp(t), n < 0 ? t : r.cmp(e) > 0 ? e : new i(r);
};
p.comparedTo = p.cmp = function(t) {
  var e, n, r, i, s = this, a = s.d, o = (t = new s.constructor(t)).d, c = s.s, u = t.s;
  if (!a || !o)
    return !c || !u ? NaN : c !== u ? c : a === o ? 0 : !a ^ c < 0 ? 1 : -1;
  if (!a[0] || !o[0])
    return a[0] ? c : o[0] ? -u : 0;
  if (c !== u)
    return c;
  if (s.e !== t.e)
    return s.e > t.e ^ c < 0 ? 1 : -1;
  for (r = a.length, i = o.length, e = 0, n = r < i ? r : i; e < n; ++e)
    if (a[e] !== o[e])
      return a[e] > o[e] ^ c < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ c < 0 ? 1 : -1;
};
p.cosine = p.cos = function() {
  var t, e, n = this, r = n.constructor;
  return n.d ? n.d[0] ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + k, r.rounding = 1, n = Xn(r, qt(r, n)), r.precision = t, r.rounding = e, y(ne == 2 || ne == 3 ? n.neg() : n, t, e, !0)) : new r(1) : new r(NaN);
};
p.cubeRoot = p.cbrt = function() {
  var t, e, n, r, i, s, a, o, c, u, l = this, f = l.constructor;
  if (!l.isFinite() || l.isZero())
    return new f(l);
  for (x = !1, s = l.s * j(l.s * l, 1 / 3), !s || Math.abs(s) == 1 / 0 ? (n = P(l.d), t = l.e, (s = (t - n.length + 1) % 3) && (n += s == 1 || s == -2 ? "0" : "00"), s = j(n, 1 / 3), t = U((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), s == 1 / 0 ? n = "5e" + t : (n = s.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), r = new f(n), r.s = l.s) : r = new f(s.toString()), a = (t = f.precision) + 3; ; )
    if (o = r, c = o.times(o).times(o), u = c.plus(l), r = I(u.plus(l).times(o), u.plus(c), a + 2, 1), P(o.d).slice(0, a) === (n = P(r.d)).slice(0, a))
      if (n = n.slice(a - 3, a + 1), n == "9999" || !i && n == "4999") {
        if (!i && (y(o, t + 1, 0), o.times(o).times(o).eq(l))) {
          r = o;
          break;
        }
        a += 4, i = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (y(r, t + 1, 1), e = !r.times(r).times(r).eq(l));
        break;
      }
  return x = !0, y(r, t, f.rounding, e);
};
p.decimalPlaces = p.dp = function() {
  var t, e = this.d, n = NaN;
  if (e) {
    if (t = e.length - 1, n = (t - U(this.e / k)) * k, t = e[t], t)
      for (; t % 10 == 0; t /= 10)
        n--;
    n < 0 && (n = 0);
  }
  return n;
};
p.dividedBy = p.div = function(t) {
  return I(this, new this.constructor(t));
};
p.dividedToIntegerBy = p.divToInt = function(t) {
  var e = this, n = e.constructor;
  return y(I(e, new n(t), 0, 1, 1), n.precision, n.rounding);
};
p.equals = p.eq = function(t) {
  return this.cmp(t) === 0;
};
p.floor = function() {
  return y(new this.constructor(this), this.e + 1, 3);
};
p.greaterThan = p.gt = function(t) {
  return this.cmp(t) > 0;
};
p.greaterThanOrEqualTo = p.gte = function(t) {
  var e = this.cmp(t);
  return e == 1 || e === 0;
};
p.hyperbolicCosine = p.cosh = function() {
  var t, e, n, r, i, s = this, a = s.constructor, o = new a(1);
  if (!s.isFinite())
    return new a(s.s ? 1 / 0 : NaN);
  if (s.isZero())
    return o;
  n = a.precision, r = a.rounding, a.precision = n + Math.max(s.e, s.sd()) + 4, a.rounding = 1, i = s.d.length, i < 32 ? (t = Math.ceil(i / 3), e = (1 / at(4, t)).toString()) : (t = 16, e = "2.3283064365386962890625e-10"), s = be(a, 1, s.times(e), new a(1), !0);
  for (var c, u = t, l = new a(8); u--; )
    c = s.times(s), s = o.minus(c.times(l.minus(c.times(l))));
  return y(s, a.precision = n, a.rounding = r, !0);
};
p.hyperbolicSine = p.sinh = function() {
  var t, e, n, r, i = this, s = i.constructor;
  if (!i.isFinite() || i.isZero())
    return new s(i);
  if (e = s.precision, n = s.rounding, s.precision = e + Math.max(i.e, i.sd()) + 4, s.rounding = 1, r = i.d.length, r < 3)
    i = be(s, 2, i, i, !0);
  else {
    t = 1.4 * Math.sqrt(r), t = t > 16 ? 16 : t | 0, i = i.times(1 / at(5, t)), i = be(s, 2, i, i, !0);
    for (var a, o = new s(5), c = new s(16), u = new s(20); t--; )
      a = i.times(i), i = i.times(o.plus(a.times(c.times(a).plus(u))));
  }
  return s.precision = e, s.rounding = n, y(i, e, n, !0);
};
p.hyperbolicTangent = p.tanh = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 7, r.rounding = 1, I(n.sinh(), n.cosh(), r.precision = t, r.rounding = e)) : new r(n.s);
};
p.inverseCosine = p.acos = function() {
  var t, e = this, n = e.constructor, r = e.abs().cmp(1), i = n.precision, s = n.rounding;
  return r !== -1 ? r === 0 ? e.isNeg() ? F(n, i, s) : new n(0) : new n(NaN) : e.isZero() ? F(n, i + 4, s).times(0.5) : (n.precision = i + 6, n.rounding = 1, e = e.asin(), t = F(n, i + 4, s).times(0.5), n.precision = i, n.rounding = s, t.minus(e));
};
p.inverseHyperbolicCosine = p.acosh = function() {
  var t, e, n = this, r = n.constructor;
  return n.lte(1) ? new r(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, r.rounding = 1, x = !1, n = n.times(n).minus(1).sqrt().plus(n), x = !0, r.precision = t, r.rounding = e, n.ln()) : new r(n);
};
p.inverseHyperbolicSine = p.asinh = function() {
  var t, e, n = this, r = n.constructor;
  return !n.isFinite() || n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, r.rounding = 1, x = !1, n = n.times(n).plus(1).sqrt().plus(n), x = !0, r.precision = t, r.rounding = e, n.ln());
};
p.inverseHyperbolicTangent = p.atanh = function() {
  var t, e, n, r, i = this, s = i.constructor;
  return i.isFinite() ? i.e >= 0 ? new s(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (t = s.precision, e = s.rounding, r = i.sd(), Math.max(r, t) < 2 * -i.e - 1 ? y(new s(i), t, e, !0) : (s.precision = n = r - i.e, i = I(i.plus(1), new s(1).minus(i), n + t, 1), s.precision = t + 4, s.rounding = 1, i = i.ln(), s.precision = t, s.rounding = e, i.times(0.5))) : new s(NaN);
};
p.inverseSine = p.asin = function() {
  var t, e, n, r, i = this, s = i.constructor;
  return i.isZero() ? new s(i) : (e = i.abs().cmp(1), n = s.precision, r = s.rounding, e !== -1 ? e === 0 ? (t = F(s, n + 4, r).times(0.5), t.s = i.s, t) : new s(NaN) : (s.precision = n + 6, s.rounding = 1, i = i.div(new s(1).minus(i.times(i)).sqrt().plus(1)).atan(), s.precision = n, s.rounding = r, i.times(2)));
};
p.inverseTangent = p.atan = function() {
  var t, e, n, r, i, s, a, o, c, u = this, l = u.constructor, f = l.precision, h = l.rounding;
  if (u.isFinite()) {
    if (u.isZero())
      return new l(u);
    if (u.abs().eq(1) && f + 4 <= gt)
      return a = F(l, f + 4, h).times(0.25), a.s = u.s, a;
  } else {
    if (!u.s)
      return new l(NaN);
    if (f + 4 <= gt)
      return a = F(l, f + 4, h).times(0.5), a.s = u.s, a;
  }
  for (l.precision = o = f + 10, l.rounding = 1, n = Math.min(28, o / k + 2 | 0), t = n; t; --t)
    u = u.div(u.times(u).plus(1).sqrt().plus(1));
  for (x = !1, e = Math.ceil(o / k), r = 1, c = u.times(u), a = new l(u), i = u; t !== -1; )
    if (i = i.times(c), s = a.minus(i.div(r += 2)), i = i.times(c), a = s.plus(i.div(r += 2)), a.d[e] !== void 0)
      for (t = e; a.d[t] === s.d[t] && t--; )
        ;
  return n && (a = a.times(2 << n - 1)), x = !0, y(a, l.precision = f, l.rounding = h, !0);
};
p.isFinite = function() {
  return !!this.d;
};
p.isInteger = p.isInt = function() {
  return !!this.d && U(this.e / k) > this.d.length - 2;
};
p.isNaN = function() {
  return !this.s;
};
p.isNegative = p.isNeg = function() {
  return this.s < 0;
};
p.isPositive = p.isPos = function() {
  return this.s > 0;
};
p.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
p.lessThan = p.lt = function(t) {
  return this.cmp(t) < 0;
};
p.lessThanOrEqualTo = p.lte = function(t) {
  return this.cmp(t) < 1;
};
p.logarithm = p.log = function(t) {
  var e, n, r, i, s, a, o, c, u = this, l = u.constructor, f = l.precision, h = l.rounding, _ = 5;
  if (t == null)
    t = new l(10), e = !0;
  else {
    if (t = new l(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1))
      return new l(NaN);
    e = t.eq(10);
  }
  if (n = u.d, u.s < 0 || !n || !n[0] || u.eq(1))
    return new l(n && !n[0] ? -1 / 0 : u.s != 1 ? NaN : n ? 0 : 1 / 0);
  if (e)
    if (n.length > 1)
      s = !0;
    else {
      for (i = n[0]; i % 10 === 0; )
        i /= 10;
      s = i !== 1;
    }
  if (x = !1, o = f + _, a = oe(u, o), r = e ? nt(l, o + 10) : oe(t, o), c = I(a, r, o, 1), De(c.d, i = f, h))
    do
      if (o += 10, a = oe(u, o), r = e ? nt(l, o + 10) : oe(t, o), c = I(a, r, o, 1), !s) {
        +P(c.d).slice(i + 1, i + 15) + 1 == 1e14 && (c = y(c, f + 1, 0));
        break;
      }
    while (De(c.d, i += 10, h));
  return x = !0, y(c, f, h);
};
p.minus = p.sub = function(t) {
  var e, n, r, i, s, a, o, c, u, l, f, h, _ = this, C = _.constructor;
  if (t = new C(t), !_.d || !t.d)
    return !_.s || !t.s ? t = new C(NaN) : _.d ? t.s = -t.s : t = new C(t.d || _.s !== t.s ? _ : NaN), t;
  if (_.s != t.s)
    return t.s = -t.s, _.plus(t);
  if (u = _.d, h = t.d, o = C.precision, c = C.rounding, !u[0] || !h[0]) {
    if (h[0])
      t.s = -t.s;
    else if (u[0])
      t = new C(_);
    else
      return new C(c === 3 ? -0 : 0);
    return x ? y(t, o, c) : t;
  }
  if (n = U(t.e / k), l = U(_.e / k), u = u.slice(), s = l - n, s) {
    for (f = s < 0, f ? (e = u, s = -s, a = h.length) : (e = h, n = l, a = u.length), r = Math.max(Math.ceil(o / k), a) + 2, s > r && (s = r, e.length = 1), e.reverse(), r = s; r--; )
      e.push(0);
    e.reverse();
  } else {
    for (r = u.length, a = h.length, f = r < a, f && (a = r), r = 0; r < a; r++)
      if (u[r] != h[r]) {
        f = u[r] < h[r];
        break;
      }
    s = 0;
  }
  for (f && (e = u, u = h, h = e, t.s = -t.s), a = u.length, r = h.length - a; r > 0; --r)
    u[a++] = 0;
  for (r = h.length; r > s; ) {
    if (u[--r] < h[r]) {
      for (i = r; i && u[--i] === 0; )
        u[i] = Y - 1;
      --u[i], u[r] += Y;
    }
    u[r] -= h[r];
  }
  for (; u[--a] === 0; )
    u.pop();
  for (; u[0] === 0; u.shift())
    --n;
  return u[0] ? (t.d = u, t.e = st(u, n), x ? y(t, o, c) : t) : new C(c === 3 ? -0 : 0);
};
p.modulo = p.mod = function(t) {
  var e, n = this, r = n.constructor;
  return t = new r(t), !n.d || !t.s || t.d && !t.d[0] ? new r(NaN) : !t.d || n.d && !n.d[0] ? y(new r(n), r.precision, r.rounding) : (x = !1, r.modulo == 9 ? (e = I(n, t.abs(), 0, 3, 1), e.s *= t.s) : e = I(n, t, 0, r.modulo, 1), e = e.times(t), x = !0, n.minus(e));
};
p.naturalExponential = p.exp = function() {
  return vt(this);
};
p.naturalLogarithm = p.ln = function() {
  return oe(this);
};
p.negated = p.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s, y(t);
};
p.plus = p.add = function(t) {
  var e, n, r, i, s, a, o, c, u, l, f = this, h = f.constructor;
  if (t = new h(t), !f.d || !t.d)
    return !f.s || !t.s ? t = new h(NaN) : f.d || (t = new h(t.d || f.s === t.s ? f : NaN)), t;
  if (f.s != t.s)
    return t.s = -t.s, f.minus(t);
  if (u = f.d, l = t.d, o = h.precision, c = h.rounding, !u[0] || !l[0])
    return l[0] || (t = new h(f)), x ? y(t, o, c) : t;
  if (s = U(f.e / k), r = U(t.e / k), u = u.slice(), i = s - r, i) {
    for (i < 0 ? (n = u, i = -i, a = l.length) : (n = l, r = s, a = u.length), s = Math.ceil(o / k), a = s > a ? s + 1 : a + 1, i > a && (i = a, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (a = u.length, i = l.length, a - i < 0 && (i = a, n = l, l = u, u = n), e = 0; i; )
    e = (u[--i] = u[i] + l[i] + e) / Y | 0, u[i] %= Y;
  for (e && (u.unshift(e), ++r), a = u.length; u[--a] == 0; )
    u.pop();
  return t.d = u, t.e = st(u, r), x ? y(t, o, c) : t;
};
p.precision = p.sd = function(t) {
  var e, n = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0)
    throw Error(de + t);
  return n.d ? (e = Lt(n.d), t && n.e + 1 > e && (e = n.e + 1)) : e = NaN, e;
};
p.round = function() {
  var t = this, e = t.constructor;
  return y(new e(t), t.e + 1, e.rounding);
};
p.sine = p.sin = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + k, r.rounding = 1, n = Kn(r, qt(r, n)), r.precision = t, r.rounding = e, y(ne > 2 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
p.squareRoot = p.sqrt = function() {
  var t, e, n, r, i, s, a = this, o = a.d, c = a.e, u = a.s, l = a.constructor;
  if (u !== 1 || !o || !o[0])
    return new l(!u || u < 0 && (!o || o[0]) ? NaN : o ? a : 1 / 0);
  for (x = !1, u = Math.sqrt(+a), u == 0 || u == 1 / 0 ? (e = P(o), (e.length + c) % 2 == 0 && (e += "0"), u = Math.sqrt(e), c = U((c + 1) / 2) - (c < 0 || c % 2), u == 1 / 0 ? e = "5e" + c : (e = u.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + c), r = new l(e)) : r = new l(u.toString()), n = (c = l.precision) + 3; ; )
    if (s = r, r = s.plus(I(a, s, n + 2, 1)).times(0.5), P(s.d).slice(0, n) === (e = P(r.d)).slice(0, n))
      if (e = e.slice(n - 3, n + 1), e == "9999" || !i && e == "4999") {
        if (!i && (y(s, c + 1, 0), s.times(s).eq(a))) {
          r = s;
          break;
        }
        n += 4, i = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (y(r, c + 1, 1), t = !r.times(r).eq(a));
        break;
      }
  return x = !0, y(r, c, l.rounding, t);
};
p.tangent = p.tan = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 10, r.rounding = 1, n = n.sin(), n.s = 1, n = I(n, new r(1).minus(n.times(n)).sqrt(), t + 10, 0), r.precision = t, r.rounding = e, y(ne == 2 || ne == 4 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
p.times = p.mul = function(t) {
  var e, n, r, i, s, a, o, c, u, l = this, f = l.constructor, h = l.d, _ = (t = new f(t)).d;
  if (t.s *= l.s, !h || !h[0] || !_ || !_[0])
    return new f(!t.s || h && !h[0] && !_ || _ && !_[0] && !h ? NaN : !h || !_ ? t.s / 0 : t.s * 0);
  for (n = U(l.e / k) + U(t.e / k), c = h.length, u = _.length, c < u && (s = h, h = _, _ = s, a = c, c = u, u = a), s = [], a = c + u, r = a; r--; )
    s.push(0);
  for (r = u; --r >= 0; ) {
    for (e = 0, i = c + r; i > r; )
      o = s[i] + _[r] * h[i - r - 1] + e, s[i--] = o % Y | 0, e = o / Y | 0;
    s[i] = (s[i] + e) % Y | 0;
  }
  for (; !s[--a]; )
    s.pop();
  return e ? ++n : s.shift(), t.d = s, t.e = st(s, n), x ? y(t, f.precision, f.rounding) : t;
};
p.toBinary = function(t, e) {
  return _t(this, 2, t, e);
};
p.toDecimalPlaces = p.toDP = function(t, e) {
  var n = this, r = n.constructor;
  return n = new r(n), t === void 0 ? n : (B(t, 0, fe), e === void 0 ? e = r.rounding : B(e, 0, 8), y(n, t + n.e + 1, e));
};
p.toExponential = function(t, e) {
  var n, r = this, i = r.constructor;
  return t === void 0 ? n = ee(r, !0) : (B(t, 0, fe), e === void 0 ? e = i.rounding : B(e, 0, 8), r = y(new i(r), t + 1, e), n = ee(r, !0, t + 1)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
p.toFixed = function(t, e) {
  var n, r, i = this, s = i.constructor;
  return t === void 0 ? n = ee(i) : (B(t, 0, fe), e === void 0 ? e = s.rounding : B(e, 0, 8), r = y(new s(i), t + i.e + 1, e), n = ee(r, !1, t + r.e + 1)), i.isNeg() && !i.isZero() ? "-" + n : n;
};
p.toFraction = function(t) {
  var e, n, r, i, s, a, o, c, u, l, f, h, _ = this, C = _.d, N = _.constructor;
  if (!C)
    return new N(_);
  if (u = n = new N(1), r = c = new N(0), e = new N(r), s = e.e = Lt(C) - _.e - 1, a = s % k, e.d[0] = j(10, a < 0 ? k + a : a), t == null)
    t = s > 0 ? e : u;
  else {
    if (o = new N(t), !o.isInt() || o.lt(u))
      throw Error(de + o);
    t = o.gt(e) ? s > 0 ? e : u : o;
  }
  for (x = !1, o = new N(P(C)), l = N.precision, N.precision = s = C.length * k * 2; f = I(o, e, 0, 1, 1), i = n.plus(f.times(r)), i.cmp(t) != 1; )
    n = r, r = i, i = u, u = c.plus(f.times(i)), c = i, i = e, e = o.minus(f.times(i)), o = i;
  return i = I(t.minus(n), r, 0, 1, 1), c = c.plus(i.times(u)), n = n.plus(i.times(r)), c.s = u.s = _.s, h = I(u, r, s, 1).minus(_).abs().cmp(I(c, n, s, 1).minus(_).abs()) < 1 ? [u, r] : [c, n], N.precision = l, x = !0, h;
};
p.toHexadecimal = p.toHex = function(t, e) {
  return _t(this, 16, t, e);
};
p.toNearest = function(t, e) {
  var n = this, r = n.constructor;
  if (n = new r(n), t == null) {
    if (!n.d)
      return n;
    t = new r(1), e = r.rounding;
  } else {
    if (t = new r(t), e === void 0 ? e = r.rounding : B(e, 0, 8), !n.d)
      return t.s ? n : t;
    if (!t.d)
      return t.s && (t.s = n.s), t;
  }
  return t.d[0] ? (x = !1, n = I(n, t, 0, e, 1).times(t), x = !0, y(n)) : (t.s = n.s, n = t), n;
};
p.toNumber = function() {
  return +this;
};
p.toOctal = function(t, e) {
  return _t(this, 8, t, e);
};
p.toPower = p.pow = function(t) {
  var e, n, r, i, s, a, o = this, c = o.constructor, u = +(t = new c(t));
  if (!o.d || !t.d || !o.d[0] || !t.d[0])
    return new c(j(+o, u));
  if (o = new c(o), o.eq(1))
    return o;
  if (r = c.precision, s = c.rounding, t.eq(1))
    return y(o, r, s);
  if (e = U(t.e / k), e >= t.d.length - 1 && (n = u < 0 ? -u : u) <= Gn)
    return i = Vt(c, o, n, r), t.s < 0 ? new c(1).div(i) : y(i, r, s);
  if (a = o.s, a < 0) {
    if (e < t.d.length - 1)
      return new c(NaN);
    if (t.d[e] & 1 || (a = 1), o.e == 0 && o.d[0] == 1 && o.d.length == 1)
      return o.s = a, o;
  }
  return n = j(+o, u), e = n == 0 || !isFinite(n) ? U(u * (Math.log("0." + P(o.d)) / Math.LN10 + o.e + 1)) : new c(n + "").e, e > c.maxE + 1 || e < c.minE - 1 ? new c(e > 0 ? a / 0 : 0) : (x = !1, c.rounding = o.s = 1, n = Math.min(12, (e + "").length), i = vt(t.times(oe(o, r + n)), r), i.d && (i = y(i, r + 5, 1), De(i.d, r, s) && (e = r + 10, i = y(vt(t.times(oe(o, e + n)), e), e + 5, 1), +P(i.d).slice(r + 1, r + 15) + 1 == 1e14 && (i = y(i, r + 1, 0)))), i.s = a, x = !0, c.rounding = s, y(i, r, s));
};
p.toPrecision = function(t, e) {
  var n, r = this, i = r.constructor;
  return t === void 0 ? n = ee(r, r.e <= i.toExpNeg || r.e >= i.toExpPos) : (B(t, 1, fe), e === void 0 ? e = i.rounding : B(e, 0, 8), r = y(new i(r), t, e), n = ee(r, t <= r.e || r.e <= i.toExpNeg, t)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
p.toSignificantDigits = p.toSD = function(t, e) {
  var n = this, r = n.constructor;
  return t === void 0 ? (t = r.precision, e = r.rounding) : (B(t, 1, fe), e === void 0 ? e = r.rounding : B(e, 0, 8)), y(new r(n), t, e);
};
p.toString = function() {
  var t = this, e = t.constructor, n = ee(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() && !t.isZero() ? "-" + n : n;
};
p.truncated = p.trunc = function() {
  return y(new this.constructor(this), this.e + 1, 1);
};
p.valueOf = p.toJSON = function() {
  var t = this, e = t.constructor, n = ee(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() ? "-" + n : n;
};
function P(t) {
  var e, n, r, i = t.length - 1, s = "", a = t[0];
  if (i > 0) {
    for (s += a, e = 1; e < i; e++)
      r = t[e] + "", n = k - r.length, n && (s += se(n)), s += r;
    a = t[e], r = a + "", n = k - r.length, n && (s += se(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; )
    a /= 10;
  return s + a;
}
function B(t, e, n) {
  if (t !== ~~t || t < e || t > n)
    throw Error(de + t);
}
function De(t, e, n, r) {
  var i, s, a, o;
  for (s = t[0]; s >= 10; s /= 10)
    --e;
  return --e < 0 ? (e += k, i = 0) : (i = Math.ceil((e + 1) / k), e %= k), s = j(10, k - e), o = t[i] % s | 0, r == null ? e < 3 ? (e == 0 ? o = o / 100 | 0 : e == 1 && (o = o / 10 | 0), a = n < 4 && o == 99999 || n > 3 && o == 49999 || o == 5e4 || o == 0) : a = (n < 4 && o + 1 == s || n > 3 && o + 1 == s / 2) && (t[i + 1] / s / 100 | 0) == j(10, e - 2) - 1 || (o == s / 2 || o == 0) && (t[i + 1] / s / 100 | 0) == 0 : e < 4 ? (e == 0 ? o = o / 1e3 | 0 : e == 1 ? o = o / 100 | 0 : e == 2 && (o = o / 10 | 0), a = (r || n < 4) && o == 9999 || !r && n > 3 && o == 4999) : a = ((r || n < 4) && o + 1 == s || !r && n > 3 && o + 1 == s / 2) && (t[i + 1] / s / 1e3 | 0) == j(10, e - 3) - 1, a;
}
function ze(t, e, n) {
  for (var r, i = [0], s, a = 0, o = t.length; a < o; ) {
    for (s = i.length; s--; )
      i[s] *= e;
    for (i[0] += pt.indexOf(t.charAt(a++)), r = 0; r < i.length; r++)
      i[r] > n - 1 && (i[r + 1] === void 0 && (i[r + 1] = 0), i[r + 1] += i[r] / n | 0, i[r] %= n);
  }
  return i.reverse();
}
function Xn(t, e) {
  var n, r, i;
  if (e.isZero())
    return e;
  r = e.d.length, r < 32 ? (n = Math.ceil(r / 3), i = (1 / at(4, n)).toString()) : (n = 16, i = "2.3283064365386962890625e-10"), t.precision += n, e = be(t, 1, e.times(i), new t(1));
  for (var s = n; s--; ) {
    var a = e.times(e);
    e = a.times(a).minus(a).times(8).plus(1);
  }
  return t.precision -= n, e;
}
var I = function() {
  function t(r, i, s) {
    var a, o = 0, c = r.length;
    for (r = r.slice(); c--; )
      a = r[c] * i + o, r[c] = a % s | 0, o = a / s | 0;
    return o && r.unshift(o), r;
  }
  function e(r, i, s, a) {
    var o, c;
    if (s != a)
      c = s > a ? 1 : -1;
    else
      for (o = c = 0; o < s; o++)
        if (r[o] != i[o]) {
          c = r[o] > i[o] ? 1 : -1;
          break;
        }
    return c;
  }
  function n(r, i, s, a) {
    for (var o = 0; s--; )
      r[s] -= o, o = r[s] < i[s] ? 1 : 0, r[s] = o * a + r[s] - i[s];
    for (; !r[0] && r.length > 1; )
      r.shift();
  }
  return function(r, i, s, a, o, c) {
    var u, l, f, h, _, C, N, $, R, z, O, D, Ve, te, ot, Ue, Ne, ut, W, $e, qe = r.constructor, ct = r.s == i.s ? 1 : -1, L = r.d, A = i.d;
    if (!L || !L[0] || !A || !A[0])
      return new qe(
        // Return NaN if either NaN, or both Infinity or 0.
        !r.s || !i.s || (L ? A && L[0] == A[0] : !A) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          L && L[0] == 0 || !A ? ct * 0 : ct / 0
        )
      );
    for (c ? (_ = 1, l = r.e - i.e) : (c = Y, _ = k, l = U(r.e / _) - U(i.e / _)), W = A.length, Ne = L.length, R = new qe(ct), z = R.d = [], f = 0; A[f] == (L[f] || 0); f++)
      ;
    if (A[f] > (L[f] || 0) && l--, s == null ? (te = s = qe.precision, a = qe.rounding) : o ? te = s + (r.e - i.e) + 1 : te = s, te < 0)
      z.push(1), C = !0;
    else {
      if (te = te / _ + 2 | 0, f = 0, W == 1) {
        for (h = 0, A = A[0], te++; (f < Ne || h) && te--; f++)
          ot = h * c + (L[f] || 0), z[f] = ot / A | 0, h = ot % A | 0;
        C = h || f < Ne;
      } else {
        for (h = c / (A[0] + 1) | 0, h > 1 && (A = t(A, h, c), L = t(L, h, c), W = A.length, Ne = L.length), Ue = W, O = L.slice(0, W), D = O.length; D < W; )
          O[D++] = 0;
        $e = A.slice(), $e.unshift(0), ut = A[0], A[1] >= c / 2 && ++ut;
        do
          h = 0, u = e(A, O, W, D), u < 0 ? (Ve = O[0], W != D && (Ve = Ve * c + (O[1] || 0)), h = Ve / ut | 0, h > 1 ? (h >= c && (h = c - 1), N = t(A, h, c), $ = N.length, D = O.length, u = e(N, O, $, D), u == 1 && (h--, n(N, W < $ ? $e : A, $, c))) : (h == 0 && (u = h = 1), N = A.slice()), $ = N.length, $ < D && N.unshift(0), n(O, N, D, c), u == -1 && (D = O.length, u = e(A, O, W, D), u < 1 && (h++, n(O, W < D ? $e : A, D, c))), D = O.length) : u === 0 && (h++, O = [0]), z[f++] = h, u && O[0] ? O[D++] = L[Ue] || 0 : (O = [L[Ue]], D = 1);
        while ((Ue++ < Ne || O[0] !== void 0) && te--);
        C = O[0] !== void 0;
      }
      z[0] || z.shift();
    }
    if (_ == 1)
      R.e = l, Rt = C;
    else {
      for (f = 1, h = z[0]; h >= 10; h /= 10)
        f++;
      R.e = f + l * _ - 1, y(R, o ? s + R.e + 1 : s, a, C);
    }
    return R;
  };
}();
function y(t, e, n, r) {
  var i, s, a, o, c, u, l, f, h, _ = t.constructor;
  e:
    if (e != null) {
      if (f = t.d, !f)
        return t;
      for (i = 1, o = f[0]; o >= 10; o /= 10)
        i++;
      if (s = e - i, s < 0)
        s += k, a = e, l = f[h = 0], c = l / j(10, i - a - 1) % 10 | 0;
      else if (h = Math.ceil((s + 1) / k), o = f.length, h >= o)
        if (r) {
          for (; o++ <= h; )
            f.push(0);
          l = c = 0, i = 1, s %= k, a = s - k + 1;
        } else
          break e;
      else {
        for (l = o = f[h], i = 1; o >= 10; o /= 10)
          i++;
        s %= k, a = s - k + i, c = a < 0 ? 0 : l / j(10, i - a - 1) % 10 | 0;
      }
      if (r = r || e < 0 || f[h + 1] !== void 0 || (a < 0 ? l : l % j(10, i - a - 1)), u = n < 4 ? (c || r) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (n == 4 || r || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (s > 0 ? a > 0 ? l / j(10, i - a) : 0 : f[h - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), e < 1 || !f[0])
        return f.length = 0, u ? (e -= t.e + 1, f[0] = j(10, (k - e % k) % k), t.e = -e || 0) : f[0] = t.e = 0, t;
      if (s == 0 ? (f.length = h, o = 1, h--) : (f.length = h + 1, o = j(10, k - s), f[h] = a > 0 ? (l / j(10, i - a) % j(10, a) | 0) * o : 0), u)
        for (; ; )
          if (h == 0) {
            for (s = 1, a = f[0]; a >= 10; a /= 10)
              s++;
            for (a = f[0] += o, o = 1; a >= 10; a /= 10)
              o++;
            s != o && (t.e++, f[0] == Y && (f[0] = 1));
            break;
          } else {
            if (f[h] += o, f[h] != Y)
              break;
            f[h--] = 0, o = 1;
          }
      for (s = f.length; f[--s] === 0; )
        f.pop();
    }
  return x && (t.e > _.maxE ? (t.d = null, t.e = NaN) : t.e < _.minE && (t.e = 0, t.d = [0])), t;
}
function ee(t, e, n) {
  if (!t.isFinite())
    return $t(t);
  var r, i = t.e, s = P(t.d), a = s.length;
  return e ? (n && (r = n - a) > 0 ? s = s.charAt(0) + "." + s.slice(1) + se(r) : a > 1 && (s = s.charAt(0) + "." + s.slice(1)), s = s + (t.e < 0 ? "e" : "e+") + t.e) : i < 0 ? (s = "0." + se(-i - 1) + s, n && (r = n - a) > 0 && (s += se(r))) : i >= a ? (s += se(i + 1 - a), n && (r = n - i - 1) > 0 && (s = s + "." + se(r))) : ((r = i + 1) < a && (s = s.slice(0, r) + "." + s.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (s += "."), s += se(r))), s;
}
function st(t, e) {
  var n = t[0];
  for (e *= k; n >= 10; n /= 10)
    e++;
  return e;
}
function nt(t, e, n) {
  if (e > Yn)
    throw x = !0, n && (t.precision = n), Error(Mt);
  return y(new t(et), e, 1, !0);
}
function F(t, e, n) {
  if (e > gt)
    throw Error(Mt);
  return y(new t(tt), e, n, !0);
}
function Lt(t) {
  var e = t.length - 1, n = e * k + 1;
  if (e = t[e], e) {
    for (; e % 10 == 0; e /= 10)
      n--;
    for (e = t[0]; e >= 10; e /= 10)
      n++;
  }
  return n;
}
function se(t) {
  for (var e = ""; t--; )
    e += "0";
  return e;
}
function Vt(t, e, n, r) {
  var i, s = new t(1), a = Math.ceil(r / k + 4);
  for (x = !1; ; ) {
    if (n % 2 && (s = s.times(e), xt(s.d, a) && (i = !0)), n = U(n / 2), n === 0) {
      n = s.d.length - 1, i && s.d[n] === 0 && ++s.d[n];
      break;
    }
    e = e.times(e), xt(e.d, a);
  }
  return x = !0, s;
}
function bt(t) {
  return t.d[t.d.length - 1] & 1;
}
function Ut(t, e, n) {
  for (var r, i = new t(e[0]), s = 0; ++s < e.length; )
    if (r = new t(e[s]), r.s)
      i[n](r) && (i = r);
    else {
      i = r;
      break;
    }
  return i;
}
function vt(t, e) {
  var n, r, i, s, a, o, c, u = 0, l = 0, f = 0, h = t.constructor, _ = h.rounding, C = h.precision;
  if (!t.d || !t.d[0] || t.e > 17)
    return new h(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : 0 / 0);
  for (e == null ? (x = !1, c = C) : c = e, o = new h(0.03125); t.e > -2; )
    t = t.times(o), f += 5;
  for (r = Math.log(j(2, f)) / Math.LN10 * 2 + 5 | 0, c += r, n = s = a = new h(1), h.precision = c; ; ) {
    if (s = y(s.times(t), c, 1), n = n.times(++l), o = a.plus(I(s, n, c, 1)), P(o.d).slice(0, c) === P(a.d).slice(0, c)) {
      for (i = f; i--; )
        a = y(a.times(a), c, 1);
      if (e == null)
        if (u < 3 && De(a.d, c - r, _, u))
          h.precision = c += 10, n = s = o = new h(1), l = 0, u++;
        else
          return y(a, h.precision = C, _, x = !0);
      else
        return h.precision = C, a;
    }
    a = o;
  }
}
function oe(t, e) {
  var n, r, i, s, a, o, c, u, l, f, h, _ = 1, C = 10, N = t, $ = N.d, R = N.constructor, z = R.rounding, O = R.precision;
  if (N.s < 0 || !$ || !$[0] || !N.e && $[0] == 1 && $.length == 1)
    return new R($ && !$[0] ? -1 / 0 : N.s != 1 ? NaN : $ ? 0 : N);
  if (e == null ? (x = !1, l = O) : l = e, R.precision = l += C, n = P($), r = n.charAt(0), Math.abs(s = N.e) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      N = N.times(t), n = P(N.d), r = n.charAt(0), _++;
    s = N.e, r > 1 ? (N = new R("0." + n), s++) : N = new R(r + "." + n.slice(1));
  } else
    return u = nt(R, l + 2, O).times(s + ""), N = oe(new R(r + "." + n.slice(1)), l - C).plus(u), R.precision = O, e == null ? y(N, O, z, x = !0) : N;
  for (f = N, c = a = N = I(N.minus(1), N.plus(1), l, 1), h = y(N.times(N), l, 1), i = 3; ; ) {
    if (a = y(a.times(h), l, 1), u = c.plus(I(a, new R(i), l, 1)), P(u.d).slice(0, l) === P(c.d).slice(0, l))
      if (c = c.times(2), s !== 0 && (c = c.plus(nt(R, l + 2, O).times(s + ""))), c = I(c, new R(_), l, 1), e == null)
        if (De(c.d, l - C, z, o))
          R.precision = l += C, u = a = N = I(f.minus(1), f.plus(1), l, 1), h = y(N.times(N), l, 1), i = o = 1;
        else
          return y(c, R.precision = O, z, x = !0);
      else
        return R.precision = O, c;
    c = u, i += 2;
  }
}
function $t(t) {
  return String(t.s * t.s / 0);
}
function yt(t, e) {
  var n, r, i;
  for ((n = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +e.slice(r + 1), e = e.substring(0, r)) : n < 0 && (n = e.length), r = 0; e.charCodeAt(r) === 48; r++)
    ;
  for (i = e.length; e.charCodeAt(i - 1) === 48; --i)
    ;
  if (e = e.slice(r, i), e) {
    if (i -= r, t.e = n = n - r - 1, t.d = [], r = (n + 1) % k, n < 0 && (r += k), r < i) {
      for (r && t.d.push(+e.slice(0, r)), i -= k; r < i; )
        t.d.push(+e.slice(r, r += k));
      e = e.slice(r), r = k - e.length;
    } else
      r -= i;
    for (; r--; )
      e += "0";
    t.d.push(+e), x && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
  } else
    t.e = 0, t.d = [0];
  return t;
}
function Qn(t, e) {
  var n, r, i, s, a, o, c, u, l;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), Dt.test(e))
      return yt(t, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (t.s = NaN), t.e = NaN, t.d = null, t;
  if (Fn.test(e))
    n = 16, e = e.toLowerCase();
  else if (Hn.test(e))
    n = 2;
  else if (Jn.test(e))
    n = 8;
  else
    throw Error(de + e);
  for (s = e.search(/p/i), s > 0 ? (c = +e.slice(s + 1), e = e.substring(2, s)) : e = e.slice(2), s = e.indexOf("."), a = s >= 0, r = t.constructor, a && (e = e.replace(".", ""), o = e.length, s = o - s, i = Vt(r, new r(n), s, s * 2)), u = ze(e, n, Y), l = u.length - 1, s = l; u[s] === 0; --s)
    u.pop();
  return s < 0 ? new r(t.s * 0) : (t.e = st(u, l), t.d = u, x = !1, a && (t = I(t, i, o * 4)), c && (t = t.times(Math.abs(c) < 54 ? j(2, c) : xe.pow(2, c))), x = !0, t);
}
function Kn(t, e) {
  var n, r = e.d.length;
  if (r < 3)
    return e.isZero() ? e : be(t, 2, e, e);
  n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : n | 0, e = e.times(1 / at(5, n)), e = be(t, 2, e, e);
  for (var i, s = new t(5), a = new t(16), o = new t(20); n--; )
    i = e.times(e), e = e.times(s.plus(i.times(a.times(i).minus(o))));
  return e;
}
function be(t, e, n, r, i) {
  var s, a, o, c, u = t.precision, l = Math.ceil(u / k);
  for (x = !1, c = n.times(n), o = new t(r); ; ) {
    if (a = I(o.times(c), new t(e++ * e++), u, 1), o = i ? r.plus(a) : r.minus(a), r = I(a.times(c), new t(e++ * e++), u, 1), a = o.plus(r), a.d[l] !== void 0) {
      for (s = l; a.d[s] === o.d[s] && s--; )
        ;
      if (s == -1)
        break;
    }
    s = o, o = r, r = a, a = s;
  }
  return x = !0, a.d.length = l + 1, a;
}
function at(t, e) {
  for (var n = t; --e; )
    n *= t;
  return n;
}
function qt(t, e) {
  var n, r = e.s < 0, i = F(t, t.precision, 1), s = i.times(0.5);
  if (e = e.abs(), e.lte(s))
    return ne = r ? 4 : 1, e;
  if (n = e.divToInt(i), n.isZero())
    ne = r ? 3 : 2;
  else {
    if (e = e.minus(n.times(i)), e.lte(s))
      return ne = bt(n) ? r ? 2 : 3 : r ? 4 : 1, e;
    ne = bt(n) ? r ? 1 : 4 : r ? 3 : 2;
  }
  return e.minus(i).abs();
}
function _t(t, e, n, r) {
  var i, s, a, o, c, u, l, f, h, _ = t.constructor, C = n !== void 0;
  if (C ? (B(n, 1, fe), r === void 0 ? r = _.rounding : B(r, 0, 8)) : (n = _.precision, r = _.rounding), !t.isFinite())
    l = $t(t);
  else {
    for (l = ee(t), a = l.indexOf("."), C ? (i = 2, e == 16 ? n = n * 4 - 3 : e == 8 && (n = n * 3 - 2)) : i = e, a >= 0 && (l = l.replace(".", ""), h = new _(1), h.e = l.length - a, h.d = ze(ee(h), 10, i), h.e = h.d.length), f = ze(l, 10, i), s = c = f.length; f[--c] == 0; )
      f.pop();
    if (!f[0])
      l = C ? "0p+0" : "0";
    else {
      if (a < 0 ? s-- : (t = new _(t), t.d = f, t.e = s, t = I(t, h, n, r, 0, i), f = t.d, s = t.e, u = Rt), a = f[n], o = i / 2, u = u || f[n + 1] !== void 0, u = r < 4 ? (a !== void 0 || u) && (r === 0 || r === (t.s < 0 ? 3 : 2)) : a > o || a === o && (r === 4 || u || r === 6 && f[n - 1] & 1 || r === (t.s < 0 ? 8 : 7)), f.length = n, u)
        for (; ++f[--n] > i - 1; )
          f[n] = 0, n || (++s, f.unshift(1));
      for (c = f.length; !f[c - 1]; --c)
        ;
      for (a = 0, l = ""; a < c; a++)
        l += pt.charAt(f[a]);
      if (C) {
        if (c > 1)
          if (e == 16 || e == 8) {
            for (a = e == 16 ? 4 : 3, --c; c % a; c++)
              l += "0";
            for (f = ze(l, i, e), c = f.length; !f[c - 1]; --c)
              ;
            for (a = 1, l = "1."; a < c; a++)
              l += pt.charAt(f[a]);
          } else
            l = l.charAt(0) + "." + l.slice(1);
        l = l + (s < 0 ? "p" : "p+") + s;
      } else if (s < 0) {
        for (; ++s; )
          l = "0" + l;
        l = "0." + l;
      } else if (++s > c)
        for (s -= c; s--; )
          l += "0";
      else
        s < c && (l = l.slice(0, s) + "." + l.slice(s));
    }
    l = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + l;
  }
  return t.s < 0 ? "-" + l : l;
}
function xt(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function er(t) {
  return new this(t).abs();
}
function tr(t) {
  return new this(t).acos();
}
function nr(t) {
  return new this(t).acosh();
}
function rr(t, e) {
  return new this(t).plus(e);
}
function ir(t) {
  return new this(t).asin();
}
function sr(t) {
  return new this(t).asinh();
}
function ar(t) {
  return new this(t).atan();
}
function or(t) {
  return new this(t).atanh();
}
function ur(t, e) {
  t = new this(t), e = new this(e);
  var n, r = this.precision, i = this.rounding, s = r + 4;
  return !t.s || !e.s ? n = new this(NaN) : !t.d && !e.d ? (n = F(this, s, 1).times(e.s > 0 ? 0.25 : 0.75), n.s = t.s) : !e.d || t.isZero() ? (n = e.s < 0 ? F(this, r, i) : new this(0), n.s = t.s) : !t.d || e.isZero() ? (n = F(this, s, 1).times(0.5), n.s = t.s) : e.s < 0 ? (this.precision = s, this.rounding = 1, n = this.atan(I(t, e, s, 1)), e = F(this, s, 1), this.precision = r, this.rounding = i, n = t.s < 0 ? n.minus(e) : n.plus(e)) : n = this.atan(I(t, e, s, 1)), n;
}
function cr(t) {
  return new this(t).cbrt();
}
function lr(t) {
  return y(t = new this(t), t.e + 1, 2);
}
function dr(t, e, n) {
  return new this(t).clamp(e, n);
}
function fr(t) {
  if (!t || typeof t != "object")
    throw Error(it + "Object expected");
  var e, n, r, i = t.defaults === !0, s = [
    "precision",
    1,
    fe,
    "rounding",
    0,
    8,
    "toExpNeg",
    -ye,
    0,
    "toExpPos",
    0,
    ye,
    "maxE",
    0,
    ye,
    "minE",
    -ye,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < s.length; e += 3)
    if (n = s[e], i && (this[n] = mt[n]), (r = t[n]) !== void 0)
      if (U(r) === r && r >= s[e + 1] && r <= s[e + 2])
        this[n] = r;
      else
        throw Error(de + n + ": " + r);
  if (n = "crypto", i && (this[n] = mt[n]), (r = t[n]) !== void 0)
    if (r === !0 || r === !1 || r === 0 || r === 1)
      if (r)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[n] = !0;
        else
          throw Error(jt);
      else
        this[n] = !1;
    else
      throw Error(de + n + ": " + r);
  return this;
}
function hr(t) {
  return new this(t).cos();
}
function pr(t) {
  return new this(t).cosh();
}
function Bt(t) {
  var e, n, r;
  function i(s) {
    var a, o, c, u = this;
    if (!(u instanceof i))
      return new i(s);
    if (u.constructor = i, Nt(s)) {
      u.s = s.s, x ? !s.d || s.e > i.maxE ? (u.e = NaN, u.d = null) : s.e < i.minE ? (u.e = 0, u.d = [0]) : (u.e = s.e, u.d = s.d.slice()) : (u.e = s.e, u.d = s.d ? s.d.slice() : s.d);
      return;
    }
    if (c = typeof s, c === "number") {
      if (s === 0) {
        u.s = 1 / s < 0 ? -1 : 1, u.e = 0, u.d = [0];
        return;
      }
      if (s < 0 ? (s = -s, u.s = -1) : u.s = 1, s === ~~s && s < 1e7) {
        for (a = 0, o = s; o >= 10; o /= 10)
          a++;
        x ? a > i.maxE ? (u.e = NaN, u.d = null) : a < i.minE ? (u.e = 0, u.d = [0]) : (u.e = a, u.d = [s]) : (u.e = a, u.d = [s]);
        return;
      } else if (s * 0 !== 0) {
        s || (u.s = NaN), u.e = NaN, u.d = null;
        return;
      }
      return yt(u, s.toString());
    } else if (c !== "string")
      throw Error(de + s);
    return (o = s.charCodeAt(0)) === 45 ? (s = s.slice(1), u.s = -1) : (o === 43 && (s = s.slice(1)), u.s = 1), Dt.test(s) ? yt(u, s) : Qn(u, s);
  }
  if (i.prototype = p, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = fr, i.clone = Bt, i.isDecimal = Nt, i.abs = er, i.acos = tr, i.acosh = nr, i.add = rr, i.asin = ir, i.asinh = sr, i.atan = ar, i.atanh = or, i.atan2 = ur, i.cbrt = cr, i.ceil = lr, i.clamp = dr, i.cos = hr, i.cosh = pr, i.div = mr, i.exp = gr, i.floor = vr, i.hypot = yr, i.ln = _r, i.log = wr, i.log10 = br, i.log2 = kr, i.max = xr, i.min = Nr, i.mod = Tr, i.mul = Er, i.pow = Sr, i.random = Cr, i.round = Zr, i.sign = Or, i.sin = Ir, i.sinh = Ar, i.sqrt = Rr, i.sub = Mr, i.sum = jr, i.tan = Pr, i.tanh = Dr, i.trunc = Lr, t === void 0 && (t = {}), t && t.defaults !== !0)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < r.length; )
      t.hasOwnProperty(n = r[e++]) || (t[n] = this[n]);
  return i.config(t), i;
}
function mr(t, e) {
  return new this(t).div(e);
}
function gr(t) {
  return new this(t).exp();
}
function vr(t) {
  return y(t = new this(t), t.e + 1, 3);
}
function yr() {
  var t, e, n = new this(0);
  for (x = !1, t = 0; t < arguments.length; )
    if (e = new this(arguments[t++]), e.d)
      n.d && (n = n.plus(e.times(e)));
    else {
      if (e.s)
        return x = !0, new this(1 / 0);
      n = e;
    }
  return x = !0, n.sqrt();
}
function Nt(t) {
  return t instanceof xe || t && t.toStringTag === Pt || !1;
}
function _r(t) {
  return new this(t).ln();
}
function wr(t, e) {
  return new this(t).log(e);
}
function kr(t) {
  return new this(t).log(2);
}
function br(t) {
  return new this(t).log(10);
}
function xr() {
  return Ut(this, arguments, "lt");
}
function Nr() {
  return Ut(this, arguments, "gt");
}
function Tr(t, e) {
  return new this(t).mod(e);
}
function Er(t, e) {
  return new this(t).mul(e);
}
function Sr(t, e) {
  return new this(t).pow(e);
}
function Cr(t) {
  var e, n, r, i, s = 0, a = new this(1), o = [];
  if (t === void 0 ? t = this.precision : B(t, 1, fe), r = Math.ceil(t / k), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(r)); s < r; )
        i = e[s], i >= 429e7 ? e[s] = crypto.getRandomValues(new Uint32Array(1))[0] : o[s++] = i % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(r *= 4); s < r; )
        i = e[s] + (e[s + 1] << 8) + (e[s + 2] << 16) + ((e[s + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(e, s) : (o.push(i % 1e7), s += 4);
      s = r / 4;
    } else
      throw Error(jt);
  else
    for (; s < r; )
      o[s++] = Math.random() * 1e7 | 0;
  for (r = o[--s], t %= k, r && t && (i = j(10, k - t), o[s] = (r / i | 0) * i); o[s] === 0; s--)
    o.pop();
  if (s < 0)
    n = 0, o = [0];
  else {
    for (n = -1; o[0] === 0; n -= k)
      o.shift();
    for (r = 1, i = o[0]; i >= 10; i /= 10)
      r++;
    r < k && (n -= k - r);
  }
  return a.e = n, a.d = o, a;
}
function Zr(t) {
  return y(t = new this(t), t.e + 1, this.rounding);
}
function Or(t) {
  return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
}
function Ir(t) {
  return new this(t).sin();
}
function Ar(t) {
  return new this(t).sinh();
}
function Rr(t) {
  return new this(t).sqrt();
}
function Mr(t, e) {
  return new this(t).sub(e);
}
function jr() {
  var t = 0, e = arguments, n = new this(e[t]);
  for (x = !1; n.s && ++t < e.length; )
    n = n.plus(e[t]);
  return x = !0, y(n, this.precision, this.rounding);
}
function Pr(t) {
  return new this(t).tan();
}
function Dr(t) {
  return new this(t).tanh();
}
function Lr(t) {
  return y(t = new this(t), t.e + 1, 1);
}
p[Symbol.for("nodejs.util.inspect.custom")] = p.toString;
p[Symbol.toStringTag] = "Decimal";
var xe = p.constructor = Bt(mt);
et = new xe(et);
tt = new xe(tt);
const Vr = d.object({
  fullAddress: d.string().nullable(),
  streetAddress1: d.string().nullable(),
  streetAddress2: d.string().nullable(),
  locality: d.string().nullable(),
  state: d.string().nullable(),
  postcode: d.string().nullable(),
  geoLat: d.union([d.number(), d.instanceof(xe)]).nullable(),
  geoLng: d.union([d.number(), d.instanceof(xe)]).nullable(),
  country: d.string().nullable()
}), Ur = Vr.omit({ fullAddress: !0 }).partial(), $r = d.string().pipe(d.coerce.date()), zt = $r, Wt = d.string().uuid(), qr = d.object({
  fullAddress: d.string(),
  isPrimary: d.boolean()
}), Br = d.object({
  NDISNumber: d.string()
}), zr = d.enum(["ACTIVE", "ENQUIRY", "ARCHIVED", "SCHEDULED_TO_BE_ARCHIVED"]), Kr = d.object({
  addresses: d.array(qr),
  attachmentUrl: d.string().optional(),
  createdOn: zt,
  customerStatus: zr,
  displayName: d.string(),
  funding: Br,
  userId: Wt,
  pinnedAlertNumber: d.number()
}), Ht = d.enum(["workflow", "booking", "planManagement", "session", "payment"]), Wr = d.enum(["read", "unread", "unseen"]), Hr = d.object({
  category: Ht,
  createdOn: zt,
  id: Wt,
  status: Wr,
  summary: d.string(),
  description: d.string(),
  meta: d.record(d.unknown())
}), Fr = d.object({
  name: Ht,
  title: d.string()
});
d.object({
  total_count: d.number().min(0),
  notifications: d.array(Hr)
});
d.object({
  categories: d.array(Fr)
});
d.object({
  category: d.array(d.string()),
  page: d.string(),
  status: d.string()
});
const Jr = d.object({
  userServiceAgreementServiceId: d.string(),
  startDate: d.union([d.string().datetime({ offset: !0 }), d.date()]).pipe(d.coerce.date()),
  endDate: d.union([d.string().datetime({ offset: !0 }), d.date()]).pipe(d.coerce.date()),
  serviceName: d.string()
}), Gr = d.object({
  userId: d.string(),
  displayName: d.string(),
  NDISNumber: d.string(),
  fullAddress: d.string(),
  attachmentUrl: d.string()
}), ei = d.object({
  serviceAgreementDetails: Jr,
  userDetails: Gr,
  serviceProviderId: d.string()
}), Yr = d.union([d.string(), d.number(), d.boolean()]), Te = d.lazy(() => d.union([Yr, d.array(Te), d.record(Te)])), Xr = d.object({
  serviceLocationId: d.string(),
  mmmGroup: d.number().nullable().optional(),
  locationType: d.string().nullable().optional(),
  ...Ur.shape
}), Qr = d.object({
  serviceAttachmentId: d.string().optional(),
  attachmentUrl: d.string().nullish().optional(),
  attachmentPath: d.string().nullish().optional(),
  attachmentType: d.string().nullish().optional()
}), ti = d.object({
  serviceName: d.string().optional(),
  serviceDescription: d.string().optional(),
  bookingPeriodType: d.string().nullish().optional(),
  bookingTimeType: d.string().optional(),
  minBookingMinutes: d.number().int().nullish().optional(),
  gapMinutes: d.number().int().nullish().optional(),
  maxBookingMinutes: d.number().int().nullish().optional(),
  recurringType: d.string().optional(),
  serviceType: d.string().optional(),
  serviceDirection: d.string().optional(),
  workerSelectionType: d.string().optional(),
  priceFrequency: d.string().nullish().optional(),
  price: d.number().nullish().optional(),
  currency: d.string().optional(),
  paymentType: d.string().nullish().optional(),
  capacity: d.number().int().nullish().optional(),
  servicePublishDate: d.date().nullish().optional(),
  status: d.string().optional(),
  createdBy: d.string().nullish().optional(),
  likeCount: d.number().int().optional(),
  dislikeCount: d.number().int().optional(),
  createdOn: d.date().optional(),
  updatedOn: d.date().nullish().optional(),
  availableFrom: d.date().nullish().optional(),
  availableTo: d.date().nullish().optional(),
  serviceConfig: Te.optional(),
  cancellationShortPeriod: d.number().int().optional(),
  serviceStockNumber: d.string().nullish().optional(),
  isPublicMarketplace: d.boolean().optional(),
  timezone: d.string().optional(),
  serviceDepartmentId: d.string().optional(),
  isUseWorkerTimeForAutoBilling: d.boolean().optional(),
  workerTimeLeeway: d.number().int().optional(),
  serviceClaimConfig: Te.optional(),
  bookingTimeWarningSource: d.string().optional(),
  canWorkerEditCheckInCheckOutTime: d.boolean().optional(),
  serviceCategory: d.string().nullish().optional(),
  groupServiceClassification: d.string().nullish().optional(),
  isFixedCapacity: d.boolean().optional(),
  teamMemberCustomerRatio: Te.optional(),
  siteCode: d.string().nullish().optional(),
  siteName: d.string().nullish().optional(),
  defaultNotePrivacyVisible: d.string().optional(),
  defaultActivityRecordIncrement: d.number().int().optional(),
  locations: d.array(Xr).optional(),
  attachments: d.array(Qr).optional(),
  rosterStartDate: d.date().nullish().optional(),
  rosterPeriod: d.string().nullish().optional()
});
export {
  ei as SILServiceDetailsResponse,
  Vr as addressSchema,
  Ur as addressUpdateSchema,
  Fr as categoryType,
  Kr as customer,
  Hr as notification,
  Qr as serviceAttachmentsUpdateSchema,
  Xr as serviceLocationUpdateSchema,
  ti as serviceUpdateSchema
};
//# sourceMappingURL=index.es.js.map
